/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerAssets.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Assets
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 07:29:03 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    ASSET_LIST_CONTAINER_LOADED,
    ASSET_LIST_CONTAINER_UNLOADED,
    ASSET_LIST_TABLE_LOADED,
    ASSET_LIST_TABLE_UNLOADED,

    ASSET_SET_GROUP_SELECT,
    ASSET_SELECT_ROW,
    ASSET_ADD,
    ASSET_EDIT,
    ASSET_DELETE,
    ASSET_OPEN_WARNING,
    ASSET_CLOSE_WARNING,
    ASSET_DELETE_DISABLE,

    ASSET_EDIT_CONTAINER_LOADED,
    ASSET_EDIT_CONTAINER_UNLOADED,
    ASSET_EDIT_FORM_LOADED,
    ASSET_EDIT_FORM_UNLOADED,
    ASSET_EDIT_DATA_LOAD,
    ASSET_EDIT_CONTAINER_SUBMIT,
    ASSET_EDIT_CONTAINER_CANCEL,
    ASSET_UPDATE_VALUE,

    ASSET_SELECT_INSPECTION_ROW
} from '../constants/actionTypeAssets';

import {
    MODAL_LOAD_SELECTWINDOW
} from '../constants/actionTypeModals';

const defaultState = {
    refreshList: false,
    danger: false,
    ASSETID: 0,
    RIGID: 0,
    RIGSECTIONID: 0,
    EQUIPMENTID: 0,
    EQUIPMENTID_DISPLAY: '',
    ASSEMBLYID: 0,
    ASSEMBLYID_DISPLAY: '',
    PEQUIPMENTSAP: '',
    PEQUIPMENTDESCRIPTION: '',
    CRITICALITYRANKING: '',
    TAGID: '',
    RFTAGID: '',
    HOSELOCATION: '',
    INSTALLDATE: '',
    LASTINSPECTDATE: '',
    NEXTINSPECTDATE: '',
    REPLACEDATE: '',
    HOSEMFGID: 0,
    HOSEPARTNUM: '',
    HOSEMEDIATYPEID: 0,
    HOSESERIALNUM: '',
    HOSETYPEID: 0,
    HOSELENGTH: '',
    HOSELENGTHUNITID: 0,
    HOSEDIAMETER: '',
    HOSEDIAMETERUNITID: 0,
    PRESSURERATING: '',
    PRESSURERATINGUNITID: 0,
    HOSEMFGDATE: '',
    HOSEANGLEID: 0,
    FIT1MFGID: 0,
    FIT1PARTNUMBER: '',
    FIT1TYPEID: 0,
    FIT1SIZE: '',
    FIT1SIZEUNITID: 0,
    FIT1MATERIALID: 0,
    FIT1GENDERID: 0,
    FIT1ANGLEID: 0,
    FIT2MFGID: 0,
    FIT2PARTNUMBER: '',
    FIT2TYPEID: 0,
    FIT2SIZE: '',
    FIT2SIZEUNITID: 0,
    FIT2MATERIALID: 0,
    FIT2GENDERID: 0,
    FIT2ANGLEID: 0,
    HOSEDAMAGEID: 0,
    FITDAMAGEID: 0,
    PEQUIPMENTSTATUSID: 0,
    PULSEID: 0,
    FLUIDCHANGEID: 0,
    ENVEXPOSUREID: 0,
    CHEALTHID: 0,
    CPRODUCTIONID: 0,
    CENVIRONMENTID: 0,
    POPERATIONALID: 0,
    PAPPLICATIONID: 0,
    PENVIRONMENTID: 0,
    RISKCLASSID: 0,
    CREATEDATE: '',
    MODIFYDATE: '',
    activeTab: '1',
    selectedInspectionID: [],
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ASSET_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                assets: action.payload[0] ? action.payload[0].records : null
            }
        case ASSET_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case ASSET_SET_GROUP_SELECT:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case ASSET_SELECT_ROW:
            return {
                ...state,
                ASSETID: action.id
            }
        case ASSET_ADD:
            return {
                ...state
            }
        case ASSET_EDIT:
            return {
                ...state,
                ASSETID: action.id
            }
        case ASSET_DELETE:
            return {
                ...state,
                ASSETID: null
            }
        case ASSET_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case ASSET_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case ASSET_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case ASSET_EDIT_CONTAINER_LOADED:
        case ASSET_EDIT_DATA_LOAD:
            return {
                ...state,
                ASSETID: action.payload[0] ? action.payload[0].ASSETID : 0,
                RIGID: action.payload[0] ? action.payload[0].RIGID : 0,
                RIGSECTIONID: action.payload[0] ? action.payload[0].RIGSECTIONID : 0,
                EQUIPMENTID: action.payload[0] ? action.payload[0].EQUIPMENTID : 0,
                EQUIPMENTID_DISPLAY: action.payload[0] ? action.payload[0].EQUIPMENT + ' [ ' + action.payload[0].SAPID + ' ]' : '',
                SUBASSEMBLYID: action.payload[0] ? action.payload[0].SUBASSEMBLYID : 0,
                SUBASSEMBLYID_DISPLAY: action.payload[0] ? action.payload[0].SUBASSEMBLY + ' [ ' + action.payload[0].SUBSAPID + ' ]' : '',
                PEQUIPMENTSAP: action.payload[0] ? action.payload[0].PEQUIPMENTSAP : '',
                PEQUIPMENTDESCRIPTION: action.payload[0] ? action.payload[0].PEQUIPMENTDESCRIPTION : '',
                CRITICALITYRANKING: action.payload[0] ? action.payload[0].CRITICALITYRANKING : '',
                TAGID: action.payload[0] ? action.payload[0].TAGID : '',
                RFTAGID: action.payload[0] ? action.payload[0].RFTAGID : '',
                HOSELOCATION: action.payload[0] ? action.payload[0].HOSELOCATION : '',
                INSTALLDATE: action.payload[0] ? action.payload[0].INSTALLDATE : '',
                LASTINSPECTDATE: action.payload[0] ? action.payload[0].LASTINSPECTDATE : '',
                NEXTINSPECTDATE: action.payload[0] ? action.payload[0].NEXTINSPECTDATE : '',
                REPLACEDATE: action.payload[0] ? action.payload[0].REPLACEDATE : '',
                HOSEMFGID: action.payload[0] ? action.payload[0].HOSEMFGID : 0,
                HOSEPARTNUM: action.payload[0] ? action.payload[0].HOSEPARTNUM : '',
                HOSEMEDIATYPEID: action.payload[0] ? action.payload[0].HOSEMEDIATYPEID : 0,
                HOSESERIALNUM: action.payload[0] ? action.payload[0].HOSESERIALNUM : '',
                HOSETYPEID: action.payload[0] ? action.payload[0].HOSETYPEID : 0,
                HOSELENGTH: action.payload[0] ? action.payload[0].HOSELENGTH : '',
                HOSELENGTHUNITID: action.payload[0] ? action.payload[0].HOSELENGTHUNITID : 0,
                HOSEDIAMETER: action.payload[0] ? action.payload[0].HOSEDIAMETER : '',
                HOSEDIAMETERUNITID: action.payload[0] ? action.payload[0].HOSEDIAMETERUNITID : 0,
                PRESSURERATING: action.payload[0] ? action.payload[0].PRESSURERATING : '',
                PRESSURERATINGUNITID: action.payload[0] ? action.payload[0].PRESSURERATINGUNITID : 0,
                HOSEMFGDATE: action.payload[0] ? action.payload[0].HOSEMFGDATE : '',
                HOSEANGLEID: action.payload[0] ? action.payload[0].HOSEANGLEID : 0,
                FIT1MFGID: action.payload[0] ? action.payload[0].FIT1MFGID : 0,
                FIT1PARTNUMBER: action.payload[0] ? action.payload[0].FIT1PARTNUMBER : 0,
                FIT1TYPEID: action.payload[0] ? action.payload[0].FIT1TYPEID : 0,
                FIT1SIZE: action.payload[0] ? action.payload[0].FIT1SIZE : '',
                FIT1SIZEUNITID: action.payload[0] ? action.payload[0].FIT1SIZEUNITID : 0,
                FIT1MATERIALID: action.payload[0] ? action.payload[0].FIT1MATERIALID : 0,
                FIT1GENDERID: action.payload[0] ? action.payload[0].FIT1GENDERID : 0,
                FIT1ANGLEID: action.payload[0] ? action.payload[0].FIT1ANGLEID : 0,
                FIT2MFGID: action.payload[0] ? action.payload[0].FIT2MFGID : 0,
                FIT2PARTNUMBER: action.payload[0] ? action.payload[0].FIT2PARTNUMBER : '',
                FIT2TYPEID: action.payload[0] ? action.payload[0].FIT2TYPEID : 0,
                FIT2SIZE: action.payload[0] ? action.payload[0].FIT2SIZE : '',
                FIT2SIZEUNITID: action.payload[0] ? action.payload[0].FIT2SIZEUNITID : 0,
                FIT2MATERIALID: action.payload[0] ? action.payload[0].FIT2MATERIALID : 0,
                FIT2GENDERID: action.payload[0] ? action.payload[0].FIT2GENDERID : 0,
                FIT2ANGLEID: action.payload[0] ? action.payload[0].FIT2ANGLEID : 0,
                HOSEDAMAGEID: action.payload[0] ? action.payload[0].HOSEDAMAGEID : 0,
                FITDAMAGEID: action.payload[0] ? action.payload[0].FITDAMAGEID : 0,
                PEQUIPMENTSTATUSID: action.payload[0] ? action.payload[0].PEQUIPMENTSTATUSID : 0,
                PULSEID: action.payload[0] ? action.payload[0].PULSEID : 0,
                FLUIDCHANGEID: action.payload[0] ? action.payload[0].FLUIDCHANGEID : 0,
                ENVEXPOSUREID: action.payload[0] ? action.payload[0].ENVEXPOSUREID : 0,
                CHEALTHID: action.payload[0] ? action.payload[0].CHEALTHID : 0,
                CPRODUCTIONID: action.payload[0] ? action.payload[0].CPRODUCTIONID : 0,
                CENVIRONMENTID: action.payload[0] ? action.payload[0].CENVIRONMENTID : 0,
                POPERATIONALID: action.payload[0] ? action.payload[0].POPERATIONALID : 0,
                PAPPLICATIONID: action.payload[0] ? action.payload[0].PAPPLICATIONID : 0,
                PENVIRONMENTID: action.payload[0] ? action.payload[0].PENVIRONMENTID : 0,
                RISKCLASSID: action.payload[0] ? action.payload[0].RISKCLASSID : 0,
                CREATEDATE: action.payload[0] ? action.payload[0].CREATEDATE : '',
                MODIFYDATE: action.payload[0] ? action.payload[0].MODIFYDATE : '',
                inspections: action.payload[1] ? action.payload[1].records : [],
                activeTab: '1',
                selectedInspectionID: [],
            }
        case ASSET_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case ASSET_SELECT_INSPECTION_ROW:
            return {
                ...state,
                INSPECTION_INSPECTIONID: action.payload ? action.payload.INSPECTIONID : 0,
                INSPECTION_HOSEDAMAGEID: action.payload ? action.payload.HOSEDAMAGEID : 0,
                INSPECTION_FITDAMAGEID: action.payload ? action.payload.FITDAMAGEID : 0,
                INSPECTION_EQUIPMENTSTATUSID: action.payload ? action.payload.EQUIPMENTSTATUSID : 0,
                INSPECTION_PULSEID: action.payload ? action.payload.PULSEID : 0,
                INSPECTION_FLUIDCHANGEID: action.payload ? action.payload.FLUIDCHANGEID : 0,
                INSPECTION_ENVEXPOSUREID: action.payload ? action.payload.ENVEXPOSUREID : 0,
                INSPECTION_HOSECONDITIONID: action.payload ? action.payload.HOSECONDITIONID : 0,
                INSPECTION_REQUESTREPLACEMENTID: action.payload ? action.payload.REQUESTREPLACEMENTID : 0,
                INSPECTION_FIT1PHOTOID: action.payload ? action.payload.FIT1PHOTOID : 0,
                INSPECTION_FIT1PHOTOID_DISPLAY: action.payload ? action.payload.FIT1PHOTOID_DISPLAY : '',
                INSPECTION_FIT1PHOTOID_URL: action.payload ? action.payload.FIT1PHOTOID_URL : '',
                INSPECTION_HOSEPHOTOID: action.payload ? action.payload.HOSEPHOTOID : 0,
                INSPECTION_HOSEPHOTOID_DISPLAY: action.payload ? action.payload.HOSEPHOTOID_DISPLAY : '',
                INSPECTION_HOSEPHOTOID_URL: action.payload ? action.payload.HOSEPHOTOID_URL : '',
                INSPECTION_FIT2PHOTOID: action.payload ? action.payload.FIT2PHOTOID : 0,
                INSPECTION_FIT2PHOTOID_DISPLAY: action.payload ? action.payload.FIT2PHOTOID_DISPLAY : '',
                INSPECTION_FIT2PHOTOID_URL: action.payload ? action.payload.FIT2PHOTOID_URL : '',
                INSPECTION_NOTES: action.payload ? action.payload.NOTES : '',
                INSPECTION_CREATEDATE: action.payload ? action.payload.CREATEDATE : '',
                INSPECTION_MODIFYDATE: action.payload ? action.payload.MODIFYDATE : '',
            }
        case MODAL_LOAD_SELECTWINDOW:
            return {
                ...state,
                equipments: action.payload[0] ? action.payload[0].records : null
            }
        case ASSET_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case ASSET_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case ASSET_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case ASSET_LIST_CONTAINER_UNLOADED:
        case ASSET_LIST_TABLE_UNLOADED:
        case ASSET_EDIT_CONTAINER_UNLOADED:
        case ASSET_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerAssets.js